import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-fill text-xl text-primary-500"></i>
              </span>
              <span className="text-lg font-bold font-heading text-foreground-950">黑料视频</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              国内领先的娱乐资讯视频聚合平台，为您提供最新、最全的吃瓜爆料视频。每日更新，免费观看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <a
                  key={cat.id}
                  href={`/category/${cat.slug}`}
                  onClick={(e) => { e.preventDefault(); navigate(`/category/${cat.slug}`); }}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="/about" onClick={(e) => { e.preventDefault(); navigate('/about'); }} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
              <span className="text-sm text-foreground-500">用户协议</span>
              <span className="text-sm text-foreground-500">隐私政策</span>
              <span className="text-sm text-foreground-500">免责声明</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <span>邮箱：contact@heiliaoshipin.com</span>
              <span>电话：400-888-8888</span>
              <span>地址：北京市朝阳区传媒产业园A座</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料视频 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer">
              <i className="ri-wechat-line text-lg text-foreground-600"></i>
            </span>
            <span className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer">
              <i className="ri-weibo-line text-lg text-foreground-600"></i>
            </span>
            <span className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer">
              <i className="ri-vidicon-line text-lg text-foreground-600"></i>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}